import { c as _c } from "react/compiler-runtime";
export interface EmptyStateProps {
  /** The ways out: to the page where the missing data is entered. */
  actions?: React.ReactNode;
  /** In brass, at 34 px. */
  icon: React.ReactNode;
  /** A word for the reader who could do without it. */
  note?: string;
  text?: string;
  title: string;
}

/**
 * What a page says when it has nothing to show yet: what is missing, and the
 * way to it.
 *
 * Drawn after the first empty state the design gave, the spring figure's: an
 * icon in brass, a title in the display face, a line or two, the actions.
 * Axes with nothing on them said none of this.
 */
export const EmptyState = t0 => {
  const $ = _c(16);
  const {
    actions,
    icon,
    note,
    text,
    title
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <span aria-hidden="true" className="text-ptl-brass [&>svg]:size-[34px]">{icon}</span>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <h2 className="ptl-display m-0 text-[30px] leading-[1.15]">{title}</h2>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== text) {
    t3 = text ? <p className="m-0 text-[15px] leading-[1.6] text-muted-foreground">{text}</p> : null;
    $[4] = text;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== note) {
    t4 = note ? <p className="m-0 text-sm leading-[1.55] text-ptl-ink-3">{note}</p> : null;
    $[6] = note;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== actions) {
    t5 = actions ? <div className="flex flex-wrap justify-center gap-2.5 pt-1.5 print:hidden">{actions}</div> : null;
    $[8] = actions;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <div className="flex max-w-[520px] flex-col items-center gap-3.5 text-center">{t1}{t2}{t3}{t4}{t5}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};